import { DocumentBranding } from 'bff'
import { cn } from '../lib/cn'

interface BrandmarkProps {
  branding: DocumentBranding
  className?: string
}

/**
 * El logo llega como data URI, no como URL: la Lambda corre dentro de la VPC y
 * una `<img>` que no resuelve produce un PDF sin logo sin fallar.
 */
export const Brandmark = ({ branding, className }: BrandmarkProps) => {
  if (!branding.logo_data_uri) {
    return (
      <span className={cn('text-[13pt] font-semibold', className)}>
        {branding.company_name}
      </span>
    )
  }

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={branding.logo_data_uri}
      alt={branding.company_name}
      className={cn('h-[14mm] w-auto object-contain', className)}
    />
  )
}
